/**
 * @file Router configuration
 * @author
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import API from '../api/index'
import store from '../store/index'

import Management from '../pages/management.vue';
import Inspection from '../pages/inspection.vue';
import Survey from '../pages/survey.vue';
import Lease from '../pages/lease.vue';
import LeaseLogin from '../pages/leaseLogin.vue';
import Site from '../pages/site.vue';
import AddActivity from '../pages/addActivity.vue';
import Href from '../pages/href.vue';

Vue.use(VueRouter);

// export default new Router({
const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'Management',
            component: Management,
            meta: {
                title: '倉儲管理系統'
            }
        },
        {
            path: '/href',
            name: 'Href',
            component: Href
        },
        {
            path: '/inspection',
            name: 'Inspection',
            component: Inspection,
            meta: {
                title: '巡檢系統'
            }
        },
        {
            path: '/survey',
            name: 'Survey',
            component: Survey,
            meta: {
                title: '巡檢系統'
            }
        },
        {
            path: '/lease',
            name: 'Lease',
            component: Lease,
            meta: {
                title: '場地租借管理系統'
            }
        },
        {
            path: '/lease-login',
            name: 'LeaseLogin',
            component: LeaseLogin,
            meta: {
                title: '場地租借系統登入'
            }
        },
        {
            path: '/site',
            name: 'Site',
            component: Site,
            meta: {
                title: '場地借用一覽'
            }
        },
        {
            path: '/addActivity',
            name: 'AddActivity',
            component: AddActivity,
            meta: {
                title: '場地預約'
            }
        }
    ]
});


router.beforeEach(function (to, from, next) {
    let System = to.query.System;
    let Ticket = to.query.Ticket;
    const host = window.location.host;

    if (host == 'irent.gov.taipei') {
        if (to.name == 'Management') {
            next({
                path: '/site',
                query: {
                    System: System,
                    Ticket: Ticket,
                }
            });
            return;
        }
        else {
            next();
        }
    }

    if (to.query.F != undefined) {
        let data = {
            "System": System,
            "Ticket": Ticket
        };
        axios.post(API.login2, data).then(res => {
            store.state.userData = res.data;

            var passId = store.state.passIDs;
            var userId = res.data.IDNumber;
            if (passId.includes(userId) === true) {
                next();
                return;
            }
            else {
                next({
                    path: '/site',
                    query: {
                        System: System,
                        Ticket: Ticket,
                    }
                });
                return;
            }
        }).catch(err => {
            next('/href')
        })
    }
    else if (to.meta.title) {
        document.title = to.meta.title
    }

    if (to.name == 'Href') {
        next();
        return;
    }
    // Backend login page, no verification needed
    if (to.name == 'LeaseLogin') {
        next();
        return;
    }
    if (to.name == 'Site' && System == undefined && Ticket == undefined) {
        next();
        return;
    }
    // Venue application form, no ID
    if (to.name == 'AddActivity' && to.query.id == undefined && (System === undefined || Ticket === undefined)) {
        next();
        return;
    }
    if (to.name == 'Lease') {
        next();
        return;
    }
    // Default will go here
    if (to.query.qrcode == undefined) {
        let data = {
            "System": System,
            "Ticket": Ticket
        }
        axios.post(API.login2, data).then(res => {
            store.state.userData = res.data;
            next();
        }).catch(err => {
            next('/href')
        })
    } else {
        if (to.name == 'Inspection' || to.name == 'Survey') {
            axios.get(API.getProfile).then(res => {
                store.state.userData = res.data;
                next()
            }).catch(err => {
                console.error('Error getting user');
                next('/href');
            })
        } else {
            next();
        }
    }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js